export default {
    methods: {
        openNewLoadingWindow() {
            const ref = window.open('/res/loading.html', '_blank')
            ref.addEventListener("DOMContentLoaded", () => {
                ref.document.title = this.$t('bookings.loadingDocument')
            });

            return ref
        }
    }
}
